import colorsVars from 'styles/colors.module.scss';

const { customScrollTrack, customScrollThumb } = colorsVars;
export const customScroll = {
    '&::WebkitScrollbar': {
        width: '10px',
        height: '1.2rem',
    },
    '&::WebkitScrollbarTrack': {
        webkitBoxshadow: `inset 0 0 6px ${customScrollTrack}`,
        borderRadius: '10px',
        backgroundColor: customScrollTrack,
    },
    '&::WebkitScrollbarThumb': {
        borderRadius: '10px',
        webkitBoxshadow: `inset 0 0 6px ${customScrollThumb}`,
        backgroundColor: customScrollThumb,
    },
};
